import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectTicketState = (state: AppState) =>
  state.ticket;


export const selectTicketsLoading = createSelector(
  selectTicketState,
  (state) => state.ticketsLoading
);

export const selectTickets = createSelector(
  selectTicketState,
  (state) => state.tickets
);

export const selectAllTickets = createSelector(
  selectTicketState,
  (state) => state.allTickets
);

export const selectTicketsPage = createSelector(
  selectTicketState,
  (state) => state.paging
);

export const selectAddSuccessTicket = createSelector(
  selectTicketState,
  (state) => state.addSuccess
);

export const selectCloseSuccessTicket = createSelector(
  selectTicketState,
  (state) => state.closeSuccess
);
